import React from 'react';
import { GlobalHotKeys } from 'react-hotkeys';
import PropTypes from 'prop-types';

const ReasonOptionSelector = ({
  reasonOptions,
  selectReasonOption,
  deselectReasonOption,
  selectedReasonOptions,
  filterPredicate
}) => {


  const selectReasonOptionShortcut = optionNumber => {
    const optionPressed = parseInt(optionNumber);
    const filteredOptions = reasonOptions.filter(filterPredicate);

    if (optionPressed > filteredOptions.length) return;

    const ro = filteredOptions[optionPressed - 1];
    const isChecked = selectedReasonOptions.indexOf(ro.reasonOptionId) > -1;

    if (isChecked) {
      deselectReasonOption(ro.reasonOptionId);
    }
    else {
      selectReasonOption(ro.reasonOptionId);
    }
  }

  const keyMap = {
    SELECT_RO_ONE: ["1"],
    SELECT_RO_TWO: ["2"],
    SELECT_RO_THREE: ["3"],
    SELECT_RO_FOUR: ["4"],
    SELECT_RO_FIVE: ["5"],
    SELECT_RO_SIX: ["6"],
    SELECT_RO_SEVEN: ["7"],
    SELECT_RO_EIGHT: ["8"],
    SELECT_RO_NINE: ["9"]
  }

  const keyHandler = {
    SELECT_RO_ONE: event => {
      selectReasonOptionShortcut("1")
    },
    SELECT_RO_TWO: event => {
      selectReasonOptionShortcut("2")
    },
    SELECT_RO_THREE: event => {
      selectReasonOptionShortcut("3")
    },
    SELECT_RO_FOUR: event => {
      selectReasonOptionShortcut("4")
    },
    SELECT_RO_FIVE: event => {
      selectReasonOptionShortcut("5")
    },
    SELECT_RO_SIX: event => {
      selectReasonOptionShortcut("6")
    },
    SELECT_RO_SEVEN: event => {
      selectReasonOptionShortcut("7")
    },
    SELECT_RO_EIGHT: event => {
      selectReasonOptionShortcut("8")
    },
    SELECT_RO_NINE: event => {
      selectReasonOptionShortcut("9")
    }
  }

  return (
    <GlobalHotKeys keyMap={keyMap} handlers={keyHandler} allowChanges={true}>
      <div>
        <div>
          <h4>Select Reason Option(s):</h4>
        </div>

        <div>
          {
            reasonOptions.filter(filterPredicate).map((x, index) => {
              const isChecked = selectedReasonOptions.indexOf(x.reasonOptionId) > -1;

              return (
                <div key={x.reasonOptionId}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => {
                      isChecked ?
                        deselectReasonOption(x.reasonOptionId) :
                        selectReasonOption(x.reasonOptionId)
                    }}
                  />
                  <b>{index + 1}.</b>
                  {x.displayName}
                </div>
              );
            })
          }
        </div>
      </div>
    </GlobalHotKeys>
  );
};

ReasonOptionSelector.propTypes = {
  reasonOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectReasonOption: PropTypes.func.isRequired,
  deselectReasonOption: PropTypes.func.isRequired,
  selectedReasonOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  filterPredicate: PropTypes.func.isRequired
};

export default ReasonOptionSelector;
